import config from '../data/config.json';
import dict from '../data/dictionary.json';

import Mustache from 'mustache';

import { Solr, Sesion } from '../main.js';
import { Mimapa } from './map.js';
import { sugeLugaresTemplate } from '../data/htmlTemplates.js';
import { getIconoLugar } from './icons.js';
import { getLiteral } from './util.js';
import { sendEvent } from './events.js';

///////////////////////////////////////////////
// RENDER DEL BOTÓN Y CAJETÍN DE BUSCAR LUGARES
function renderEntradaLugares(mostrar) {
	if (mostrar && Solr != null) {
		// muestro botón
		document.getElementById("toggle_lugares").classList.remove("d-none");
		// muestro input búsqueda si está activado
		const activado = document.getElementById("in_bot_lugares").checked;
		if (activado) {
			document.getElementById("lugares_heading").classList.remove("d-none");
			// pongo el focus en el input
			document.getElementById("in_lugares").focus();
		}
		else {
			document.getElementById("lugares_heading").classList.add("d-none");
			// si había marcador de municipio, lo quito
			if (Sesion.lugarmarker != null) {
				Sesion.lugarmarker.remove();
				Sesion.lugarmarker = null;
				Sesion.lugar = null;
			}
		}
	}
	else {
		document.getElementById("toggle_lugares").classList.add("d-none");
		document.getElementById("lugares_heading").classList.add("d-none");
	}
}

///////////////////////////
// OBTENCIÓN DE SUGERENCIAS
async function obtenerSugerenciasLugares(entrada) {
	try {
		// hago la llamada a solr y espero resultados
		const datos = await Solr.getSuggestions(entrada);
		// extraigo sugerencias
		let keys = Object.keys(datos.suggest.mySuggester);
		if (keys.length > 0) 
			return datos.suggest.mySuggester[keys[0]];
		else // si no hay resultados, mando un objeto nuevo
			return {'numFound': 0};
	} catch(err) {
		reject(err);
	}
}

/////////////////////
// RENDER SUGERENCIAS
function renderSugerenciasLugares(resultados) {
	// objeto sugerencias
	let sinfo = {};
	sinfo.sugerencias = [];
	
	// formateo las sugerencias
	if (resultados.numFound == 0)
		sinfo.nosugerencias = true;
	else {
		for (let ind =0; ind < resultados.suggestions.length; ind++) {
			sinfo.sugerencias.push(
				{
					'id': resultados.suggestions[ind].payload, // el id
					'name': resultados.suggestions[ind].term // la sugerencia
				}
			);
		}
	}
	
	// muestro sugerencias
	let cont = Mustache.render(sugeLugaresTemplate, sinfo);
	document.getElementById("sugelugares").innerHTML = cont;
		
	// handler de los botones de sugerencias de lugares
	document.querySelectorAll(".bot_suge_lugar").forEach(function(button) {
		button.addEventListener('click', async function() {
			// obtengo id de la sugerencia
			const id = this.getAttribute("id");
			// pedimos la información del lugar
			const datos = await Solr.getDocument(id);
			// si hay algo, vamos al primero
			if (datos.response.numFound > 0)
				seleccionarLugar(datos.response.docs[0]);
		});
	});
	
	// inicializo focus
	Sesion.lugarfocus = -1;
}

///////////////
// AJUSTE FOCUS
function ajustarLugarfocus() {
	// Sesion.lugarfocus = 0; => cajetín entrada
	// Sesion.lugarfocus = i; => num de sugerencia
	// obtengo número de sugerencias
	const ns = Array.from(document.getElementById("sugelugares").children)
		.filter(child => !child.disabled).length;
	// reajusto índice del focus si hace falta
	if (ns == 0) Sesion.lugarfocus = -1;
	else if (Sesion.lugarfocus >= ns) Sesion.lugarfocus = 0;
	else if (Sesion.lugarfocus < 0) Sesion.lugarfocus = ns -1;
	// y ahora las cosas visuales
	Array.from(document.getElementById("sugelugares").children).forEach(function(child) {
        child.classList.remove("active");
    });
	if (Sesion.lugarfocus >= 0)
		document.getElementById("sugelugares").children[Sesion.lugarfocus].classList.add("active");
}

////////////////////
// SELECCIONAR LUGAR
function seleccionarLugar(lugar) {
	// pongo nombre	en la entrada
    document.getElementById("in_lugares").value = lugar.name;
	
	// escondo la lista de sugerencias
    document.getElementById("sugelugares").classList.add("d-none");
	
	// inicializo focus
	Sesion.lugarfocus = -1;
	
	// si había marcador de lugar, lo quito
	if (Sesion.lugarmarker != null)
		Sesion.lugarmarker.remove();
		
	// pongo tooltip y marcador en el lugar
	let tooltip = '<strong>'+lugar.name+'</strong>';
	// pongo el tipo de lugar
	tooltip += '<br>' + getLiteral(dict[lugar.feature_code]);
	// población
	if (lugar.population > 0)
		tooltip += '<br>'+getLiteral(dict.population)+': '+Number(lugar.population).toLocaleString();
	// coordenadas
	const coords = [lugar.latitude, lugar.longitude];
	// pongo marcador
	Sesion.lugarmarker = L.marker(coords, {icon: getIconoLugar()})
		.bindTooltip(tooltip)
		.addTo(Mimapa);
		
	// guardo lugar en la sesión (para poder hacer un zoom si se pulsa intro en la entrada)
	Sesion.lugar = lugar;
	
	// mando evento de selección de lugar a GA
	sendEvent( 'select_content', { content_type: 'place_selection', content_id: lugar.name } );
	
	// navegamos al municipio
	Mimapa.flyTo(coords, config.zLugar, {animate: true, duration: 1});
}

export { renderEntradaLugares, obtenerSugerenciasLugares, renderSugerenciasLugares, ajustarLugarfocus };